import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col } from 'antd';

import { useLibertyMutualSubStepsContext } from '../../../context';
import { Topic, Value } from '../styles';

export const VideoDuration = () => {
	const {
		libertyMutualResult: {
			informations: { duration }
		}
	} = useLibertyMutualSubStepsContext();

	return (
		<Col xs={24}>
			<Topic>{I18n.get('Video duration')}:</Topic>
			<Value>{duration}</Value>
		</Col>
	);
};
